import { render, staticRenderFns } from "./FConfirmation.vue?vue&type=template&id=2007a8c2&scoped=true&"
import script from "./FConfirmation.vue?vue&type=script&lang=ts&"
export * from "./FConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./FConfirmation.vue?vue&type=style&index=0&id=2007a8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007a8c2",
  null
  
)

export default component.exports